import { makeGetDictionariesKnmKindsSelectOptions } from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getErknmAnalyticsData = (state: IRootState) => state.erknmAnalytics.data;
export const getErknmAnalyticsFilter = (state: IRootState) => state.erknmAnalytics.filter;
export const getErknmAnalyticsTableColumns = (state: IRootState) => state.erknmAnalytics.tableColumns;
export const getErknmAnalyticsDateTime = (state: IRootState) => state.erknmAnalytics.localDateTime;
export const getErknmAnalyticsKnmOrder = (state: IRootState) => state.erknmAnalytics.knmOrder;

export const getErknmAnalyticsKnmKindSelectOptions = (state: IRootState) => {
  const getDictionariesKnmKindsSelectOptions = makeGetDictionariesKnmKindsSelectOptions();

  return getDictionariesKnmKindsSelectOptions(state, undefined);
};
